import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{! RESPONSIBLE TEAM: team-channels }}\n<Inbox2::Spam />",{ moduleName: "embercom/templates/inbox/workspace/spam.hbs" })